import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../utils/Common';
import ListaReportesNETJET from './componentes/ListaReportesNETJET';
import LineaDeAvance from './componentes/LineaDeAvance';
import { dateFormatConDia } from '../../../../utils/DateFunctions';

const NETJET = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [filtros, setfiltros] = useState({ fecha: '', valvula: 0, rancho: 0 });
    const [opciones, setopciones] = useState({ valvulas: [], ranchos: [] });
    const [listaFertilizacion, setlistaFertilizacion] = useState([]);
    const [totales, settotales] = useState({
        "camas_ocupadas": 0,
        "fertilizante_exacto": 0,
        "fertilizante_ceil": 0,
        "evapotranspiracion": null
    });
    var counter = 0;
    useEffect(() => {
        getData(filtros, true)
    }, []);

    const keyGen = () => {
        counter++;
        return counter;
    }

    const getData = async (fil = { ...filtros }, conAnimacionCarga = false) => {
        let resp = await Post('api/general/netjet', fil, 'POST', conAnimacionCarga ? setloader : false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        setopciones({ valvulas: resp.data.valvulas, ranchos: resp.data.ranchos });
        setfiltros({ ...fil, fecha: resp.data.fecha });
        settotales(resp.data.totales);
        setlistaFertilizacion(resp.data.lista);
    }

    const changeValue = (e) => {
        let { name, value } = e.target;
        let fil = { ...filtros, [name]: value };
        setfiltros(fil);
        getData(fil, true);
    }

    const actualizarPadre = async (accion, cargaUtil) => {
        let data = {};
        if (accion === 'actualizar cama') return await actualizarCama(cargaUtil);
    }

    const actualizarCama = async (cargaUtil) => {
        let data = { ...filtros, ['camaInfo']: cargaUtil };
        let resp = await Post('api/general/netjet/switch', data, 'POST', false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return false;
        }
        setopciones({ valvulas: resp.data.valvulas, ranchos: resp.data.ranchos });
        settotales(resp.data.totales);
        setlistaFertilizacion(resp.data.lista);
        return true;

    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>
                    Aplicación refuerzos de levante
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>FECHA</label>
                    <input
                        type="date"
                        name='fecha'
                        className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center'
                        value={filtros.fecha}
                        onChange={changeValue}
                    />
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>FILTRADO POR RANCHO</label>
                    <select className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center' name='rancho' value={filtros.rancho | ''} onChange={changeValue}>
                        <option value='' >Todos los ranchos</option>
                        {
                            opciones.ranchos.map((rancho, i) => <option key={keyGen()} value={rancho.id}>{rancho.nombre}</option>)
                        }
                    </select>
                </div>

                <div className='bw-200 m-1'>
                    <label className='text-bold w-100 text-center text-s'>VALVULAS</label>
                    <select className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center' name='valvula' value={filtros.valvula | ''} onChange={changeValue}>
                        <option value='' >Todas las valvulas</option>
                        {
                            opciones.valvulas.map((valvula, i) => <option key={keyGen()} value={valvula.id}>{valvula.rancho} °°° {valvula.nombre}</option>)
                        }
                    </select>
                </div>
                <div className='bw-250 m-1'>
                    <label className='text-bold w-100 text-center text-s'>CAMAS FERTILIZADAS</label>
                    <div className='w-100 border-bottom border-info round-xxl text-center mt-2 text-bold'>
                        {totales.aplicadosTotales}<span className='text-xs text-400 me-1 ms-1'>de</span>
                        {totales.camas_ocupadas}<span className='text-xs text-400 ms-1'>CAMAS</span>
                    </div>
                </div>
                <div className='w-100' />
                <LineaDeAvance avance={totales.camas_ocupadas > 0 ? totales.aplicadosTotales / totales.camas_ocupadas * 100 : 0} height='3' />
                <div className='w-100' />
                {listaFertilizacion.length > 0 && <ListaReportesNETJET data={listaFertilizacion} fecha={filtros.fecha} actualizarPadre={actualizarPadre} />}
                {filtros.fecha !== "" && listaFertilizacion.length === 0 && <div className='w-100 mt-5 text-center text-300 h3'>No hay datos ingresados para {dateFormatConDia(filtros.fecha)}</div>}
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default NETJET;